import { useTranslation } from 'react-i18next';

export default function PostSubmitGuide() {
  const { t } = useTranslation();
  const steps = [
    { numKey: 'consultation.post.step1.num', titleKey: 'consultation.post.step1.title', descKey: 'consultation.post.step1.desc' },
    { numKey: 'consultation.post.step2.num', titleKey: 'consultation.post.step2.title', descKey: 'consultation.post.step2.desc' },
    { numKey: 'consultation.post.step3.num', titleKey: 'consultation.post.step3.title', descKey: 'consultation.post.step3.desc' },
  ];
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('consultation.post.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('consultation.post.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('consultation.post.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto">
            {t('consultation.post.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {steps.map((step) => (
            <div key={step.numKey} className="card-glow bg-background-100/60 border border-background-200/60 p-6 text-center relative">
              <div className="w-8 h-8 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/[0.08]">
                <span className="text-accent-500 text-[14px] font-medium tracking-[0.06em]">{t(step.numKey)}</span>
              </div>
              <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-2">
                {t(step.titleKey)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(step.descKey)}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-[14px] text-foreground-400 tracking-[0.04em] mt-8">
          {t('consultation.post.urgentNote')}{' '}
          <a href="tel:0368244086" className="text-accent-600 hover:text-accent-500 transition-colors">03-6824-4086</a>
          {' '}{t('consultation.post.urgentSuffix')}
        </p>
      </div>
    </section>
  );
}
